module.exports = __webpack_public_path__ + "sleepy.97063499.png";